<div class="main-menu nav">
  <ul class="list-group">
    @for (menu of visibleMenus; track menu) {
      @if (menu.href?.length) {
        <li class="list-group-item list-group-item-action">
          <a
            [href]="menu.href"
            target="_blank"
            [ngbPopover]="menu.label | translate"
            placement="right"
            triggers="mouseenter:mouseleave">
            <ng-container [ngTemplateOutlet]="menuContent" [ngTemplateOutletContext]="{ menu }" />
          </a>
        </li>
      }
      @if (menu.routerLink?.length) {
        <li
          [routerLink]="menu.routerLink"
          routerLinkActive="active"
          class="list-group-item list-group-item-action"
          [ngbPopover]="menu.label | translate"
          placement="right"
          triggers="mouseenter:mouseleave"
          (click)="setSubmenu(menu)">
          <ng-container [ngTemplateOutlet]="menuContent" [ngTemplateOutletContext]="{ menu }" />
        </li>
      }
    }
  </ul>
</div>

<ng-template #menuContent let-menu="menu">
  @if (menu.iconType === 'icon') {
    <app-icon iconType="pbi" [iconName]="menu.icon" [outline]="!menu.icon.includes('pbi-icon-mini')" customClass="x2" />
  }
  @if (menu.iconType === 'image') {
    <img [src]="menu.icon" alt="Icon" />
  }
  @if (menuService.displayMenuLabel()) {
    <b>
      {{ menu.label | translate }}
      @if (menu.routerLink === validerPlisRoute && pendingValidationsCount() > 0) {
        <span class="badge badge-notification">
          {{ pendingValidationsCount() }}
        </span>
      }
    </b>
  }
</ng-template>
